import React  from 'react';
import { List, Segment, Divider, Table, Grid, Image, Header, Icon, Accordion,Progress, Popup, Container, Label} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
//import { Progress } from 'antd';
//import '../../App.css';
 
/*

{row.icon=="video play"?    
                                                        <div>
                                                            {row.time+" min."}
                                                        </div>
                                                    :
                                                        <div> </div> 
                                                    }
                                                    
                                                    {moment(row.fechaInicioExamen.substring(0,10)).isSame(moment().format("MM/DD/YYYY"))?
                                            {row.icon=="video play"&&row.time!=null&&row.time>0?    
                                                <strong>
                                                visualizado  -{" "+Math.round(row.tiempoVideo/60)} min. de {Math.round(row.time/60)} min. aprx.
                                                </strong>
                                                :
                                                ""
                                            }
                                            
                                            
         <Header as='h3' >
                     {modulo.titulo}
                </Header>
                <Header as='h4' floated='left'>
                    {modulo.descripcion}
                     <Header.Subheader>
                       {modulo.contenido.length} actividades
                    </Header.Subheader>
                </Header>
                <Header as='h6' floated='right'>
                    <Icon size="tiny" color={modulo.activo?"grey":"blue"}  name={modulo.activo?"minus":"plus"} link onClick={()=>onAcordionModulo(modulo.id)}/>
                </Header>
                                            
            myMoment.diff(yourMoment) >= 0
                                                                            
              {fechaActual.isBetween(moment(row.fechaInicioExamen).subtract(1, 'days'), moment(row.fechaTerminoExamen).add(1, 'days'), '[]')?                                     
*/


const Modulos=({ id, margenes, onVisible, modulos, onAcordionModulo, olor, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, showModalComents, handleClick, fechaActual, fechaComentario, titulo, allowAccess})=>{

    	return (
        <Segment>
        
        {modulos.map(modulo =>
            <div>
            
            {fechaActual.diff(moment(modulo.fechaInicio))>=0?
            <>
         
         
                <Segment ribbon style={{ background: "#B8D8D5"}} >
                       <Grid>
                            <Grid.Row columns="2" >
                            <Grid.Column width="13"  only='computer tablet '>
                                <Label as='a' onClick={()=>onAcordionModulo(modulo.id)} color='teal' ribbon size="big">
                                  {modulo.titulo}
                                </Label>    

                                <br/><br/>

                                <Header as='h5' floated='left'>
                                    {modulo.descripcion}
                                    <Header.Subheader>
                                        {modulo.contenido.length} actividades
                                    </Header.Subheader>
                                </Header>

                            </Grid.Column>

                            <Grid.Column width="13"  only='mobile'>
                                <Label as='a' onClick={()=>onAcordionModulo(modulo.id)} color='teal' ribbon size="medium">
                                  {modulo.titulo}
                                </Label>    

                                <br/><br/>

                                <Header  floated='left'>
                                    {modulo.descripcion}
                                    <Header.Subheader>
                                        {modulo.contenido.length} actividades
                                    </Header.Subheader>
                                </Header>

                            </Grid.Column>               
                            <Grid.Column width="3" textAlign='right' verticalAlign="middle">
                                <Icon size="large" color={modulo.activo?"grey":"teal"}  name={modulo.activo?"minus":"plus"} link onClick={()=>onAcordionModulo(modulo.id)}/>
                            </Grid.Column>

                        </Grid.Row>
                     </Grid>
                </Segment>
        
        

        
        
                {modulo.activo?
                <Segment basic >

                {modulo.contenidoView.map(rowView =>
                <Segment.Group >
                      <Segment basic ribbon style={{ background: "#E7F0EF"}}>

                            <Grid>
                            <Grid.Row >
                            <Grid.Column only='computer tablet '>

                                <Label as='a'   ribbon style={{ background: "#B8D8D5"}} size="large">
                                 {rowView.agrupador+" - "+rowView.fecha}
                                </Label>          

                            </Grid.Column>

                            <Grid.Column only='mobile'>

                                <Label as='a'   ribbon style={{ background: "#B8D8D5"}} size="small">
                                 {rowView.agrupador+" - "+rowView.fecha}
                                </Label>          

                            </Grid.Column>    

                            </Grid.Row>
                            </Grid>

                            </Segment>

                                        {rowView.contenido.map(row =>
                                            <Segment color="teal">
                                                               
                                                            
                                               <Grid>
                                                    <Grid.Row columns="2" >
                                                    <Grid.Column width="13">
                                                    <Header as='h4'>
                                                        {row.visto==1?<Icon color='green' name='checkmark'/>:""}
                                                        <Header.Content>
                                                        {row.titulo}        

                                                         <Header.Subheader>
                                                           {row.desc+ " "}
                                                            {row.idTipoContenido==28 && row.fechaInicioExamen!=null?
                                                                <><br/>
                                                                    Activo el día: {row.fechaInicioExamen.substring(0,10)} al {row.fechaTerminoExamen.substring(0,10)}
                                                                </>                                    
                                                                :
                                                                ""
                                                            }


                                                        </Header.Subheader>
                                                        </Header.Content>
                                                    </Header> 

                                                    </Grid.Column>    
                                                    <Grid.Column width="3" textAlign='right'>









                                                    {row.idTipoContenido==28  && row.fechaInicioExamen!=null?
                                                     <>

                                                        {allowAccess==null || allowAccess=="N"?

                                                        <>
                                                            {fechaActual.isBetween(moment(moment(row.fechaInicioExamen).format('YYYY-MM-DD')), moment(moment(row.fechaTerminoExamen).format('YYYY-MM-DD')).add(1, 'days'), '[]')?


                                                                    <Icon size="large" color={row.color} link onClick={()=>onVisible(row.id)} name={row.icon} />

                                                            :
                                                                 <Popup
                                                                    trigger={
                                                                        <Icon size="large" color="red"  name="ban" />
                                                                    }
                                                                    content="Examen bloqueado, favor de regresar en la fecha indicada"
                                                                 />         
                                                            }
                                                        </>

                                                        :

                                                            <Icon size="large" color={row.color} link onClick={()=>onVisible(row.id)} name={row.icon} />

                                                        }

                                                     </>
                                                    :
                                                        <>

                                                            {row.url!=null?

                                                                <Icon size="large" color={row.color} link onClick={()=>handleClick(row.url, row.id)} name={row.icon} />

                                                            :



                                                                <Icon size="large" color={row.color} link onClick={()=>onVisible(row.id)} name={row.icon} />




                                                            }

                                                        </>
                                                    }



                                                        &nbsp;


                                                        {row.fechaUltimoComentario==null?

                                                          <Popup
                                                                trigger={
                                                                    <Icon size="large" color="blue" link onClick={()=>showModalComents(row.id, row.idModuloContenido)}  name="comment" />

                                                                 }
                                                                content="Sin comentarios"
                                                              />
                                                        :

                                                            <>
                                                             {moment(row.fechaUltimoComentario).isBetween(moment(fechaComentario), moment(fechaActual))  ?
                                                                    <Popup
                                                                        trigger={
                                                                           <Icon size="large" color="green" link onClick={()=>showModalComents(row.id, row.idModuloContenido)}  name="comment" />
                                                                        }
                                                                        content={"Último comentario:"+row.fechaUltimoComentario}
                                                                      />
                                                                 :
                                                                    <Popup
                                                                        trigger={
                                                                            <Icon size="large" color="olive" link onClick={()=>showModalComents(row.id, row.idModuloContenido)}  name="comment" />
                                                                        }
                                                                        content={"Último comentario hace más de 5 dias ("+ row.fechaUltimoComentario +")"}
                                                                      />        
                                                                }

                                                            </>
                                                        }

                                                </Grid.Column>

                                            </Grid.Row>


                                                    {row.icon=="video play"?    
                                                      <>
                                                                {row.tiempoVideo==null?
                                                                        ""
                                                                    :

                                                                     <Grid.Row >
                                                                        <Grid.Column> 

                                                                       {(row.time/60)<row.tiempoVideo?                    
                                                                         <Progress  success  size='small' 
                                                                             progress='percent' 
                                                                             percent={Math.round((Math.round(Number(row.tiempoVideo/60)))/(Math.round(Number(row.time/60)))*100)}
                                                                         >
                                                                             visualizado  -{" "+Math.round(row.tiempoVideo/60)} min. de {Math.round(row.time/60)} min. aprx.
                                                                            </Progress>
                                                                        :        
                                                                        <Progress  warning size='small'
                                                                            progress='percent' 
                                                                           percent={Math.round((Math.round(Number(row.tiempoVideo/60)))/(Math.round(Number(row.time/60)))*100)}
                                                                        >  
                                                                             visualizado  -{" "+Math.round(row.tiempoVideo/60)} min. de {Math.round(row.time/60)} min. aprx.
                                                                        </Progress>
                                                                        }
                                                                        </Grid.Column>    
                                                                    </Grid.Row>

                                                                }
                                                        </>        

                                                    :
                                                        "" 
                                                    }



                                            </Grid>
                                            
                                            
                                      
                                            

                                            </Segment>
                                        )}	


                            </Segment.Group>
                        )}
                </Segment>:""
                }
                
                
            </> 
            :
                ""
            }
            

            </div>
        )}	
    
        
     
        </Segment>
	);
};



export default Modulos;